import { render } from "./FactSummary.vue?vue&type=template&id=11f9cd46&scoped=true"
import script from "./FactSummary.vue?vue&type=script&lang=js"
export * from "./FactSummary.vue?vue&type=script&lang=js"

import "./FactSummary.vue?vue&type=style&index=0&id=11f9cd46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f9cd46"]])

export default __exports__